import LoadingBar from './loadingBar';

export default LoadingBar;
